export enum ListInclusion {
  All = `all`,
  Matching = `matching`,
}

export enum ListQuantifier {
  // for filters
  Any = `any`,
  All = `all`,
  /** for breakdowns ([tech spec](https://www.notion.so/mxpnl/Breakdown-QApi-Implementation-d35e842315024db78e10f72c179878b2)) */
  Flatten = `flatten`,
}

export enum SCDOptionsType {
  /** If any value of the SCD property within the date range matches */
  Any = `any`,
  /** If the latest value *as of event time* of the SCD property matches */
  Latest = `latest`,
  /** SCD value on a particular date */
  Fixed = `fixed`,
}

// TODO: This is model representation. These are also used as the display names
// in the UI. There should be a mapping from model representation to display names as
// the model shouldn't change, but the display names can.

export enum StringOperator {
  Contains = `contains`,
  DoesNotContain = `does not contain`,
  DoesNotEqual = `does not equal`,
  Equals = `equals`,
  NotSet = `is not set`,
  Set = `is set`,
}

export enum ObjectOperator {
  Equals = `equals`,
  Set = `is set`,
}

export enum NumberOperator {
  AtLeast = `is at least`,
  Between = `is between`,
  NotBetween = `is not between`,
  EqualTo = `is equal to`,
  NotEqualTo = `is not equal to`,
  GreaterThan = `is greater than`,
  LessThan = `is less than`,
  AtMost = `is at most`,
  Set = `is set`,
  NotSet = `is not set`,
}

export enum ListOperator {
  Contains = `contains`,
  DoesNotContain = `does not contain`,
}

export enum BooleanOperator {
  True = `true`,
  False = `false`,
}

export enum BooleanFilterOperator {
  True = `is true`,
  False = `is false`,
}

export enum CohortOperator {
  In = `in`,
  NotIn = `not in`,
}

export enum LogicalOperator {
  And = `and`,
  Not = `not`,
  Or = `or`,
}

export enum NthTimeOperator {
  NthTime = `nth time`,
  FirstTimeInPeriod = `first time in period`,
  LastTimeInPeriod = `last time in period`,
}

export enum DateRangeType {
  Between = `between`,
  NotBetween = `not between`,
  On = `on`,
  NotOn = `not on`,
  RelativeAfter = `in the last`,
  NotRelativeAfter = `not in the last`,
  RelativeBefore = `before the last`,
  RelativeFuture = `in the next`,
  Since = `since`,
  Before = `before`,
  StartsOn = `starts on`,
  EndsOn = `ends on`,
}

export type FilterOperator =
  | StringOperator
  | NumberOperator
  | DateRangeType
  | ListOperator
  | BooleanOperator
  | ObjectOperator
  | LogicalOperator
  | NthTimeOperator;
